import React from 'react';

export const MaintenancePage: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0a1628 0%, #1a2940 50%, #0d2137 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      color: '#e2e8f0',
      padding: '20px',
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '520px',
      }}>
        <div style={{ fontSize: '64px', marginBottom: '24px' }}>🚀</div>
        <h1 style={{
          fontSize: '28px',
          fontWeight: 700,
          marginBottom: '16px',
          color: '#ffffff',
        }}>
          AssessAI Has Moved
        </h1>
        <p style={{
          fontSize: '16px',
          lineHeight: 1.6,
          color: '#94a3b8',
          marginBottom: '24px',
        }}>
          AssessAI has been moved to a new domain. Please update your bookmarks as this domain will be decommissioned soon.
        </p>
        <a
          href="https://assessai.mmsa.aws.dev/"
          style={{
            display: 'inline-block',
            padding: '12px 32px',
            borderRadius: '8px',
            background: 'rgba(59, 130, 246, 0.15)',
            border: '1px solid rgba(59, 130, 246, 0.4)',
            color: '#60a5fa',
            fontSize: '16px',
            fontWeight: 600,
            textDecoration: 'none',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(59, 130, 246, 0.25)';
            e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.6)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(59, 130, 246, 0.15)';
            e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.4)';
          }}
        >
          Go to assessai.mmsa.aws.dev →
        </a>
        {/* Original maintenance message - commented out temporarily
        <p style={{
          fontSize: '16px',
          lineHeight: 1.6,
          color: '#94a3b8',
          marginBottom: '32px',
        }}>
          We're currently enhancing Assess AI with important updates to improve your experience, performance and security. Our team is working diligently to complete this maintenance as quickly as possible. Thank you for your understanding as we make these improvements.
        </p>
        <div style={{
          display: 'inline-block',
          padding: '10px 24px',
          borderRadius: '8px',
          background: 'rgba(59, 130, 246, 0.1)',
          border: '1px solid rgba(59, 130, 246, 0.3)',
          color: '#60a5fa',
          fontSize: '14px',
        }}>
          Please check back soon
        </div>
        */}
      </div>
    </div>
  );
};
